import { Box, Container, Flex, Image } from "@chakra-ui/react";
// import UploadButton from "./UploadButton";
import UserButton from "./UserButton";
import InputComponent from "./InputComponent";
import { Link, useLocation } from "react-router-dom";
import CartNavbar from "./CartNavbar";
import WholesaleButton from "./WholesaleButton";
import { Location } from "react-router-dom";
const TopNavbar = () => {
  let isLoggedIn = localStorage.getItem("isLoggedIn");
  return (
    <>
    <Box
      top="0px"
      position="fixed"
      width={"100%"}
      zIndex="1"
    >
      
      <Container width={"100%"} maxW='100%' bg={"rgb(255,255,255)"} paddingBlock="15px" >
        <Flex justifyContent={"center"} gap="20px" alignItems={"center"}>
          <Link to={"/"}>
            <Box paddingRight={"20px"}>
              <Image
                src="https://i.ibb.co/1959HjW/udyog-logo-home.png"
                alt="Udyog Logo"
                w={"168px"}
                minWidth="50px"
                maxWidth="50px"
              ></Image>
            </Box>
          </Link>
          {isLoggedIn ? <InputComponent /> : <></>}
          {/* <UploadButton /> */}
          <Link to={"/Cart"}>
            <CartNavbar />
          </Link>

         <UserButton />
         {isLoggedIn && <Link to={"/"}> <WholesaleButton /></Link>}  
        </Flex>
      </Container>
    </Box>
    <Box width={"100%"} height="90px" bg={"rgb(255,255,255)"}></Box>
    </>
  );
};

export default TopNavbar;
